import { render, staticRenderFns } from "./v-banner.vue?vue&type=template&id=78a5e2b4&scoped=true&"
import script from "./v-banner.vue?vue&type=script&lang=js&"
export * from "./v-banner.vue?vue&type=script&lang=js&"
import style0 from "./v-banner.vue?vue&type=style&index=0&id=78a5e2b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5e2b4",
  null
  
)

export default component.exports